import { render } from "./ContactCard.vue?vue&type=template&id=9943ecb0"
import script from "./ContactCard.vue?vue&type=script&lang=js"
export * from "./ContactCard.vue?vue&type=script&lang=js"
script.render = render

export default script